module.exports = __webpack_public_path__ + "static/media/iconfinder_website_-_bookmark_3440843.b6da053a.png";